__webpack_require__.p = "/cb_pen_drawingapp/";